import { Redirect, Route, Switch } from "react-router-dom";
import React from "react";

import MarketingProductList from "./product/MarketingProductList";
import MarkettingProductContent from "./product/MarkettingProductContent";
import RAPromotionList from "./ra-promotion/RAPromotionList";
import HardPromotionDetail from "./hard-promotion/hard-promotion-detail.jsx";
import HardPromotionList from "./hard-promotion/hard-promotion-list.jsx";

import Error404 from "../Error404";

export default ({ match }) => {
  return (
    <Switch>
      <Redirect path={match.path} exact to={`${match.path}/product`} />
      <Route
        path={`${match.path}/product`}
        exact
        children={<MarketingProductList />}
      />
      <Route
        path={`${match.path}/product/:id`}
        exact
        children={<MarkettingProductContent />}
      />
      <Route
        path={`${match.path}/ra-promotion`}
        exact
        children={<RAPromotionList />}
      />
      <Route
        path={`${match.path}/hard-promotion`}
        exact
        children={<HardPromotionList />}
      />
      <Route
        path={`${match.path}/hard-promotion/:id`}
        exact
        children={<HardPromotionDetail />}
      />
      <Route component={Error404} />
    </Switch>
  );
};
